/**
 * Formats a temperature (stored as °C) for display,
 * converting to °F when isMetric is false.
 */
export function formatTemp(celsius: number, isMetric: boolean): string {
  if (isMetric) return `${celsius}°C`;
  return `${(celsius * 9 / 5 + 32).toFixed(1)}°F`;
}
